module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Shield-thunder-57f96bb0f5f7300a598adb66f0b654f2.svg";